// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section[data-v-337f2ea8]{padding:1em 0 3em}.add-a-review.desktop[data-v-337f2ea8]{margin:auto;max-width:var(--legacy-page-width-max);width:100%}.add-a-review.desktop[data-v-337f2ea8] .field-label,.add-a-review.desktop[data-v-337f2ea8] .ratings-section>label,.add-a-review.desktop[data-v-337f2ea8] label.asblock>span{font-size:19px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
